<template>
	<section class="resource-content-slim">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-7 col-md-7">
					<div class="page-summary-container">
						<div class="details-title">
							{{ resource.title }}
						</div>
						<div class="hidden-xs">
							<hr/>
							<p v-html="resource.body"/>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-sm-5 col-md-4 col-md-offset-1">
					<div class="well well-details">
						<div class="padding-bottom-10">
							<template v-if="resource.regions && resource.regions.length > 0" >
								<div class="sm-padding-bottom-10">
									<b-btn
										v-for="region in resource.regions"
										:key="region.id"
										class="label label-red"
									>
										&nbsp;{{ region.name }}&nbsp;
									</b-btn>
								</div>
							</template>
							<template v-else>
								<div class="sm-padding-bottom-10">
									<span class="label label-default">No regions set</span>
								</div>
							</template>
						</div>
						<div
							class="padding-bottom-10"
							v-if="resource.reference !== undefined && resource.reference.length > 0"
						>
							Reference: {{ resource.reference }}
						</div>
						<div class="padding-bottom-10">
							Date: {{ formattedStartDate }}
						</div>
						<div class="padding-bottom-10">
							<span class="label label-status">{{ resource.status.name }}</span>
						</div>
						<div v-if="resource.tags && resource.tags.length > 0" class="padding-bottom-30">
							<template v-for="tag in resource.tags">
								<b-btn :key="tag.id" class="label label-gray">{{ tag.name }}</b-btn>
							</template>
						</div>
						<div v-if="files && files.length > 0">
							<template v-for="(fileGroup, fileIndex) in files">
								<div
									:key="`group-${fileIndex}`"
									class="downloads-head-panel brand-primary-bg white"
									@click="showFiles(fileIndex)"
								>
									<div class="padding-10-15">
										<div class="row">
											<div class="col-xs-10">
												{{ fileGroup.group }}
											</div>
											<div class="col-xs-2">
												<i class="material-icons" style="float: right;">expand_more</i>
											</div>
										</div>
									</div>
									<b-collapse
										v-model="show[fileIndex]"
										:key="`dropdown-${fileIndex}`"
										class="padding-10-15 collapse"
									>
										<div class="row">
											<div class="col-xs-12">
												<template v-for="file in fileGroup.items">
													<b-btn
														:key="`file-${file.id}`"
														:href="file.key"
														type="info"
														class="btn btn-xs btn-info"
														target="_blank"
														@click="downloadFile(file.id)"
													>
														{{ file.language }}
													</b-btn>
												</template>
											</div>
										</div>
									</b-collapse>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-sm-7 col-md-7">
					<div class="visible-xs">
						<div class="message-title">Message</div>
						<p v-html="resource.body"/>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="less" scoped>
	.container {
		min-height: 650px;
	}
	.btn-info {
		margin-right: 5px;
	}
</style>

<script>
import { map, flow, groupBy, orderBy } from 'lodash/fp';
import moment from 'moment';
import languages from 'language-list';
import { Notification } from 'uiv';

export default {
	created() {
		this.getResource();
	},
	data() {
		return {
			resource: {
				title: null,
				content: null,
				reference: null,
				start_date: null,
				end_date: null,
				status: {
					id: null,
					name: null
				}
			},
			files: [],
			show: []
		};
	},
	computed: {
		formattedStartDate() {
			return moment(this.resource.start_date).format('DD/MM/YYYY');
		},
		formattedEndDate() {
			return moment(this.resource.end_date).format('DD/MM/YYYY');
		},
	},
	methods: {
		showFiles(index) {
			this.$set(this.show, index, !this.show[index]);
		},
		async getResource() {
			const { id } = this.$route.params;
			const { data: { data: resource } } = await this.$axios.get(`/resource/${id}`);
			const files = flow(
				map(({ group, language, ...rest }) => ({
					group_id: group.id,
					group_name: group.name,
					language: languages().getLanguageName(language),
					...rest
				})),
				orderBy('language', 'asc'),
				groupBy('group_id'),
				map(eachGroup => ({ group: eachGroup[0].group_name, items: [...eachGroup] }))
			)(resource.files);

			const show = map(value => value === false, files);

			this.$set(this, 'resource', resource);
			this.$set(this, 'files', files);
			this.$set(this, 'show', show);
		},
		async downloadFile(id) {
			try {
				await this.$axios.post(`/download/${id}`);
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: 'Could not download resource.',
					content: e.response ? e.response.data.message : '',
					duration: 10000
				});
			}
		}
	},
	watch: {
		'$route.params.id': async function resourceIdWatcher() {
			this.getResource();
		},

	}
};
</script>
